import { FC, ReactElement } from 'react';

import { useNavigate } from 'react-router-dom';

import { Accordion, IconButton } from '../../compositions';
import { AccountNavigationItem as AccountNavigationItemInterface } from '../../entities/@account/Account/Account';
import { AppRoute, appRoutes } from '../../entities/Routing/Routing';
import { useDeviceWidth, useTrans } from '../../hooks';
import { logout } from '../../redux/@account/authentication/authenticationActions';
import { useTypedDispatch } from '../../redux/store';
import { AccountNavigationItem } from './subcomponents';

import './AccountNavigationSidebar.scss';

interface AccountNavigationSidebarProps {
    className?: string;
}

export const AccountNavigationSidebar: FC<AccountNavigationSidebarProps> = ({
    className = '',
}): ReactElement => {
    const trans = useTrans();
    const dispatch = useTypedDispatch();
    const navigate = useNavigate();
    const { isMobile } = useDeviceWidth();

    const navigationItems: AccountNavigationItemInterface[] = [
        {
            id: 1,
            icon: 'dashboard',
            link: {
                label: trans(appRoutes[AppRoute.accountDashboard].label),
                href: trans(appRoutes[AppRoute.accountDashboard].path),
            },
        },
        {
            id: 2,
            icon: 'user',
            link: {
                label: trans(appRoutes[AppRoute.accountData].label),
                href: trans(appRoutes[AppRoute.accountData].path),
            },
        },
        {
            id: 3,
            icon: 'orders',
            link: {
                label: trans(appRoutes[AppRoute.accountOrderOverview].label),
                href: trans(appRoutes[AppRoute.accountOrderOverview].path),
            },
        },
        {
            id: 4,
            icon: 'heart',
            link: {
                label: trans(appRoutes[AppRoute.accountWishlist].label),
                href: trans(appRoutes[AppRoute.accountWishlist].path),
            },
        },
        {
            id: 5,
            icon: 'lock',
            link: {
                label: trans(appRoutes[AppRoute.accountChangePassword].label),
                href: trans(appRoutes[AppRoute.accountChangePassword].path),
            },
        },
    ];

    const handleLogOut = async (): Promise<void> => {
        await dispatch(logout());

        navigate(trans(appRoutes[AppRoute.home].path));
    };

    return (
        <aside className={`account-navigation-sidebar ${className}`}>
            {isMobile ? (
                <Accordion heading={trans('containers.accountNavigationSidebar.accountNavigation')}>
                    <nav aria-label={trans('containers.accountNavigationSidebar.accountNavigation')}>
                        <ul className="account-navigation-sidebar__list">
                            {navigationItems.map(item => (
                                <AccountNavigationItem
                                    key={item.id}
                                    icon={item.icon}
                                    to={item.link.href}
                                    label={item.link.label}
                                    className="account-navigation-sidebar__item"
                                    navLinkClassName="account-navigation-sidebar__link"
                                />
                            ))}
                        </ul>

                        <IconButton
                            icon="logout"
                            text={trans('common.logOut')}
                            onClick={handleLogOut}
                            className="account-navigation-sidebar__logout-button"
                            iconClassName="account-navigation-sidebar__logout-button-icon"
                            labelClassName="account-navigation-sidebar__logout-button-label"
                        />
                    </nav>
                </Accordion>
            ) : (
                <nav aria-label={trans('containers.accountNavigationSidebar.accountNavigation')}>
                    <ul className="account-navigation-sidebar__list">
                        {navigationItems.map(item => (
                            <AccountNavigationItem
                                key={item.id}
                                icon={item.icon}
                                to={item.link.href}
                                label={item.link.label}
                                className="account-navigation-sidebar__item"
                                navLinkClassName="account-navigation-sidebar__link"
                            />
                        ))}
                    </ul>

                    <IconButton
                        icon="logout"
                        text={trans('common.logOut')}
                        onClick={handleLogOut}
                        className="account-navigation-sidebar__logout-button"
                        iconClassName="account-navigation-sidebar__logout-button-icon"
                        labelClassName="account-navigation-sidebar__logout-button-label"
                    />
                </nav>
            )}
        </aside>
    );
};
